<template>
  <Modal 
    :id="'cmp-add-licenceAccounts'"
    @cancelled="onCancel"
  >
    
    <template slot="header">{{$t('licence_reminder')}} </template>

    <template slot="body">
      <table class="dt-table2 contact-table">
        <thead class="dt-table2--head">
          <tr
            class="dt-table2--row"
            :style="{
                        'margin-right': hRowMarginRight
                    }"
          >
            <th class="dt-table2--column">Name</th>
            <th style="max-width:100px" class="dt-table2--column"></th>
            <th style="max-width:30px" class="dt-table2--column"></th>
          
          </tr>
        </thead>
        <tbody class="dt-table2--body">
        <tr
          class="dt-table2--row"
          v-for="item in list"
          :key="item.licence_account_id"
        >
            <td class="dt-table2--column">{{item['licence_account_name']}}</td>
            <td style="max-width:100px" class="dt-table2--column">{{item['total']}} {{$t('licences')}}</td>
            <td style="max-width:30px" class="dt-table2--column">
              <div style="margin: 0 auto">
                <div class="dt-icon-container">
                  <img
                    src="static/icons/email/email-grey.svg"
                    class="dt-icon v5 s1"
                    @click="(e) => onClickMail(item)"
                    alt="Mail File"
                    title="Mail File"
                  />
                </div>
              </div>   
              
            </td>
         
          </tr>
        </tbody>
      </table>
    </template>

    <template slot="options">
        <button class="dt-button s6" @click="onCancel">Cancel</button>
        <button class="dt-button v1 s6" @click="onOKClick">Send All</button>
        
    
 
      
    </template>

  </Modal>
</template>

<script>
// import { BookingStoreNamespace as storeNS, BookingStoreNamespace } from '../../../store';
// import * as ActionTypes from '../../../store/types';

// import {mapGetters, mapActions} from 'vuex';


import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";

import InputField from "@/plugins/text-field/input-field";

import { waitForAnimation, subscribeSubject } from "@/utility";

import Modal from '../../../../dt-plugins/modal/modal';
import { createModalMixin, closeModal2Route, openModal2Route } from "../../../../dt-plugins/modal/modal.mixin";
import { licenceService } from '../../services/licence.service';
import { sendMail, sendMailHref } from '../../../../utility';




export default {
  props: {


  },
  components: {
    InputField,

    Modal
  },
  mixins: [
 
  ],
  // watch: {
  //   searchString: {
  //     immediate: true,
  //     handler: function(to, from) {
  //       console.log(`searchString Change to ${to} from ${from}`);
  //     }
  //   }
  // },
  data: function() {
    return {
      list: [],
      searchString: "",
     
     
      searchSize: "single",

      
    
     

    
    
    };
  },
  mounted:async function() {
 
    
    const resData= await licenceService.lcncAccForBatchRemainder({...this.$route.query.payload});

    //console.log("RESDATA:::::",this.$route.query.payload);

    console.log(":::RESDATA:::",resData); 
    this.list=resData.data.lcnc_acc;


  },
  computed: {

    
    hRowMarginRight: function() {
     
        return "38px";
    },
  
    external_id: function() {
      return this.$route.query.external_id;
    },


  },
  methods: {
    onClickMail:async function(item){
      
       console.log(this.$route.query.payload,":::::::")
      const { email } = this.$route.query.payload
      const resData = await licenceService.licenceAccountReminderEmail({...this.$route.query.payload,email:item.email ,licence_account_id:item.licence_account_id });

      console.log(":::::::::::::::",resData,":::::::::::::::");
      
      let emailBody = resData.data.licences.reduce((accum,cur)=>{
       
       const trackReduce =cur['tracks'].reduce((a,c)=>{
          return a+=`${c['artist']} ${c['title']} ${c['version']}\n`
       },'')

       return accum+=`${cur['licence_name']}\nType: ${cur['licence_type']} (${cur['exclusivity']})\n\nTracks:\n ${trackReduce}\n\nLast Statement: ${cur['last_statements']}\n----------------------------------------`
      },'')

     

      const emailBodyFinal = `${email}\n----------------------------------------\n${emailBody}`

      //console.log(emailBody,"::::emailBody")


      //const emailBody = `${this.$route.query.payload}\n`
      
      sendMailHref({subject:'',body:emailBodyFinal,mails:[item.email]});

    },
    onCancel: function() {
  
      this.$emit("cancelled", true);
    },

    onOKClick: function() {
      this.list.forEach(e=>{
        this.onClickMail(e);
      });
      this.onCancel();
      
    }
  }
};


</script>

<style lang="scss" scoped>
.dt-modal--body {
  margin-left: 0px;
}

.contact-search {
  height: 30px;
  width: 290px;
}

.contact-table {
  margin-top: 10px;

  tbody {
    min-height: 380px;
  }
}

.dt-table2 {
  --body-height: 380px;
  --row-height: 28px;

  display: flex;
  flex-direction: column;

  &--head {
  }
  th.dt-table2--column {
    text-align: left;
    color: #828282;
    font-weight: 400;
  }
  &--body {
    background: #f8f8f8;

    display: flex;
    flex-direction: column;

    border: 1px solid var(--sprt-5);
    border-radius: 3px;

    .dt-table2--row {
      border-bottom: 1px solid var(--sprt-7);
    }

    max-height: var(--body-height);
    overflow: auto;
  }
  &--row {
    display: flex;
    flex-direction: row;
    padding: 5px;
    margin: 0px 10px;

    min-height: var(--row-height);
    cursor: pointer;

    &:hover {
      //background: rgb(235, 235, 235);
    }
  }
  &--column {
    flex: 1;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.dt-modal--options {

  button{
      &:first-child {
          margin-right: 10px;
      }
      &:last-child {
          margin-left:0px 10px;
      }
  }
}
</style>